function Buttons() {
	this.build();
}

Buttons.prototype.build = function () {
	const arrow = `<svg width="20" height="7" viewBox="0 0 20 7" xmlns="http://www.w3.org/2000/svg">
<path d="M19.9064 3.24661L17.2499 0.114988C17.1258 -0.0272775 16.9249 -0.0437636 16.7803 0.10062C16.651 0.229696 16.6478 0.481438 16.7673 0.621603L18.8998 3.1315L0.33207 3.1315C0.148668 3.1315 0 3.29644 0 3.49992C0 3.7034 0.148668 3.86836 0.33207 3.86836L18.8998 3.86836L16.7673 6.37826C16.6478 6.51841 16.6563 6.76396 16.7803 6.89922C16.9112 7.04202 17.1277 7.02931 17.2499 6.88486L19.9064 3.75324C19.9844 3.6683 19.9987 3.5865 20 3.49999C20 3.41474 19.9535 3.30154 19.9064 3.24661Z"/>
</svg>`;

	$('.btn').each(function(index, elem) {
		$(elem).append(arrow);
	});
};
